import { Field, FieldWrapper, Form, FormElement } from '@progress/kendo-react-form';
import React,{ useState , useEffect} from 'react';
import { useHistory } from 'react-router-dom';
import FormContainer from '../components/FormContainer';
import headerImg from '../images/Stepper2.png'; 
import stepper from '../hybridImages/Stepper2.png';
import pStepper from '../hybridImages/PStepper2.png';  
import subAPImg from '../images/SubAPStepper2.png';
import personDtlsData from '../data/persondetailsdata.json'
import { FormTitle,CusFormSectionLabel, FormComboBox, CusFormComboBox } from '../validation/Form-Components';
import SubHeader from '../components/SubHeader';
import ToggleShowDetails from '../components/ToggleShowDetails';
import AuthPerson from './AuthPerson';
import config from '../appconfig/config.json';
import service from '../services/PersonDtlsApiService';
import Loading from '../components/Loading';
import helper from '../factory/Helper.js';
import MyInfoPersonDetails from '../components/MyInfoPersonDetails';
import marStatusArray from '../data/maritalstatus.json'
import titles from '../data/titles.json';
import storage from '../factory/StorageFactory';
import CusToast from '../components/CusToast';
import countriesDomicile from '../data/domicilecountries.json';
import mData from '../hybriddata/mainform.json';
import { Button } from "@progress/kendo-react-buttons";
import { reqDDLValidator } from '../validation/Validators.jsx';
 

const SPersonDetails = (props) => {

    let timer; 
    const  authPer1 = '1', authPer2 = '2',authPer3 = '3', authPer4='4', authPer5='5';

    const dobRegex = new RegExp(/^\d{4}\-(0?[1-9]|1[012])\-(0?[1-9]|[12][0-9]|3[01])$/);  //XXXX-XX-XX

    const history = useHistory();

    const [holders, setHolders]  = useState([]);
    const [response, setResponse]  = useState();

    const [isError,setIsError] = useState(false);
    const [errMsg, setErrMsg] = useState('');

    const [isLoading, setIsLoading] = useState(true);  //to show api call
    const [isSaving,setIsSaving] = useState(false);

    //Show or Hide Details
    const [showMyInfoPersonDtls1, setShowMyInfoPersonDtls1] = useState(false);
    const [showMyInfoPersonDtls2, setShowMyInfoPersonDtls2] = useState(false);
 

    //Header Section Expend, default true
    const [isExpendAuth1,setIsExpendAuth1] = useState(true);
    const [isExpendAuth2,setIsExpendAuth2] = useState(true);
 
    const [applicantDetails1, setApplicantDetails1] = useState(null);
    const [applicantDetails2, setApplicantDetails2] = useState(null);
 
    const [loginAPCPFHistory, setLoginAPCPFHistory] = useState(null);
    const [loginAPYrAssestment, setLoginAPYrAssestment] = useState(null);
 

    const [initFormData, setInitFormData] = useState({
     
        titleCbo1:"",
        marStatusCbo1:"",
        countOfDomicileCbo1:"",
        mno1:"",
        em1:"",
        mhLoanInstallmentCbo1:"",
    
        cboAuthrisedPerson:"",
        titleCbo2:"",
        marStatusCbo2:"",
        countOfDomicileCbo2:"",
        mno2:"",
        em2:"",
        mhLoanInstallmentCbo2:""
   
    })

    useEffect(() => {

        if(helper.isTokenExpired()) {
            history.push(config.route.SessionExpired);
            return;
        }

        if(helper.isInvalidState()) {
            window.location.href =  config.link.BacktoHome;
            return;
        }

        window.scrollTo(0,0);
        getStateIdFromQueryString();
        getData();

        return () => {
            clearTimeout(timer);
            setIsLoading(false);
        };
    }, []);

    const getStateIdFromQueryString = () => {
    
        const queryString = require('query-string');
        const parsed = queryString.parse(props.location.search);
        let stateId = parsed.state;
        if(stateId) {
            storage.setStateId(stateId);
        }
    }

    const handleSubmit = (dataItem) => {

        if(helper.isTokenExpired()) {
            history.push(config.route.SessionExpired);
            return;
        }

        if(helper.isInvalidState()) {
            window.location.href =  config.link.BacktoHome;
            return;
        }

        if(dataItem.isValid) {
            let data = JSON.parse(JSON.stringify(dataItem.values));
            if(!validateApplicantDtls()) {
                if(response.ApplicantsDtlsMyInfo.isFirstUser === 'true') {
                    showErrMsg(config.error.MyInfo.MissingData);
                }
                else {
                    showErrMsg(config.error.MyInfo.MissingDataSubAP);
                }
                return;
            }
            
            if(!validateApplicantDtlsDOB()) {
                if(response.ApplicantsDtlsMyInfo.isFirstUser === 'true') { //first user
                    showErrMsg(config.error.MyInfo.InvalidDOB);
                }
                else {
                    showErrMsg(config.error.MyInfo.InvalidDOBSubAP);
                }
                return;
            }
        
            //save the form here 
            savePersonDetails(formatJsonParams(data));
        }
    }

    const handleOnToggleClick = (id) => {
     
        if(id === authPer1) {
            setShowMyInfoPersonDtls1(!showMyInfoPersonDtls1);
        }
        else if(id === authPer2) {
            setShowMyInfoPersonDtls2(!showMyInfoPersonDtls2)
        }
    }

    const savePersonDetails = (params) => {
        
        if(!validateForm(params.ApplicantDtls)) {
            return;
        }

        setIsSaving(true);
        service.put(params).then(res => {    
            setIsSaving(false);
            if(res.data.isSucess) {
                goNext();
            }  
            else {
                showErrMsg(config.error.SaveApiFailed);
            } 
        }).catch(err => {
            console.log('err: ',err);
            setIsSaving(false);
            showErrMsg(config.error.SaveApiFailed);
        })
    }
    
    const formatJsonParams = (data) => {
 
        let appDtlsArray = [];
      
        if(getLoginUserOrder(data) === authPer1) {
            if(applicantDetails1 !== null)  appDtlsArray.push(formatApplicantObj1(data));
            if(applicantDetails2 !== null)  appDtlsArray.push(formatApplicantObj2(data));
        }
        else {
            if(getLoginUserOrder(data) === authPer2) {
                if(applicantDetails2 !== null)  appDtlsArray.push(formatApplicantObj2(data));
            }
           
        }

        let params = {
            StateId:storage.getStateId(),
            ReferenceNo: storage.getRefNo(),
            ApplicantDtls:appDtlsArray
        }

        return params;
    }
    
    const formatApplicantObj1 = (data) => {
  
        let ApplicantDtls1={};
        if(applicantDetails1.hasMyInfo) {
            ApplicantDtls1 = {
                OrderNumber: authPer1,
                IDNumber: applicantDetails1.myInfo.IDNumber,  
                Person_Name: applicantDetails1.myInfo.Person_Name,   
                TitleCode: data.titleCbo1 === null || data.titleCbo1 === ''? '':data.titleCbo1.value,
                MaritalStatusCode:data.marStatusCbo1 === null || data.marStatusCbo1 === ''? '':data.marStatusCbo1.value,
                MarStatusDesp: data.marStatusCbo1 === null || data.marStatusCbo1 === ''? '':data.marStatusCbo1.label,
                CountryOfResidenceCode:data.countOfDomicileCbo1 === null || data.countOfDomicileCbo1===''? '':data.countOfDomicileCbo1.value,
                CountryOfResidenceDesc:data.countOfDomicileCbo1 === null || data.countOfDomicileCbo1===''? '': data.countOfDomicileCbo1.label,
                Position_Code:applicantDetails1.myInfo.Position_Code,
                Position_Desc:applicantDetails1.myInfo.Position_Desc,
                MobileNumber: data.mno1,
                Email_Address: data.em1,
                isJointContributerForMortgageLoan:data.mhLoanInstallmentCbo1 === null || data.mhLoanInstallmentCbo1 === ''? '':data.mhLoanInstallmentCbo1.value
            }
        }
        else {
            ApplicantDtls1 = {
                OrderNumber: authPer1,
                IDNumber: applicantDetails1.myInfo.IDNumber,  
                Person_Name: applicantDetails1.myInfo.Person_Name,   
                MobileNumber: data.mno1,
                Email_Address: data.em1
            }
        }
 
        return ApplicantDtls1;
    }

    const formatApplicantObj2 = (data) => {
   
        let ApplicantDtls2={};
        if(applicantDetails2.hasMyInfo) {
            ApplicantDtls2 = {
                OrderNumber: authPer2,
                IDNumber: applicantDetails2.myInfo.IDNumber,  
                Person_Name: applicantDetails2.myInfo.Person_Name,   
                TitleCode: data.titleCbo2 === null || data.titleCbo2 === ''? '':data.titleCbo2.value,
                MaritalStatusCode:data.marStatusCbo2 === null || data.marStatusCbo2 === ''? '':data.marStatusCbo2.value,
                MarStatusDesp: data.marStatusCbo2 === null || data.marStatusCbo2 === ''? '':data.marStatusCbo2.label,
                CountryOfResidenceCode:data.countOfDomicileCbo2 === null || data.countOfDomicileCbo2===''? '':data.countOfDomicileCbo2.value,
                CountryOfResidenceDesc:data.countOfDomicileCbo2 === null || data.countOfDomicileCbo2===''? '': data.countOfDomicileCbo2.label,
                Position_Code:applicantDetails2.myInfo.Position_Code,
                Position_Desc:applicantDetails2.myInfo.Position_Desc,
                MobileNumber: data.mno2,
                Email_Address: data.em2,
                isJointContributerForMortgageLoan:data.mhLoanInstallmentCbo2 === null || data.mhLoanInstallmentCbo2 === ''? '':data.mhLoanInstallmentCbo2.value
            }
        }
        else {
            ApplicantDtls2 = {
                OrderNumber: authPer2,
                IDNumber: applicantDetails2.myInfo.IDNumber,  
                Person_Name: applicantDetails2.myInfo.Person_Name,   
                MobileNumber: data.mno2,
                Email_Address: data.em2
            }
        }

        return ApplicantDtls2;
    }

  
    const getLoginUserOrder = () => {

        if(response.ApplicantsDtlsMyInfo.isFirstUser === 'true') {
            return authPer1;  // first user, default return 1
        }
        else {// not first login person, get current login user seq from ApplicantDtls array
            return getNonFirstUserSeq();
        }
    }

    const getNonFirstUserSeq = () => {
        if(!Array.isArray(response.ApplicantDtls)){ //check obj
            if(response.ApplicantDtls.IDNumber.trim() ===  response.ApplicantsDtlsMyInfo.IDNumber.trim()){
                return response.ApplicantDtls.OrderNumber;
            }
        }
        else { //array
            for(let i in response.ApplicantDtls) {
                if(response.ApplicantDtls[i].IDNumber.trim() ===  response.ApplicantsDtlsMyInfo.IDNumber.trim()){
                   
                    return response.ApplicantDtls[i].OrderNumber;
                }
            }
        }
    }

    const setAPExpendSection = (resData) => {
        try{
            let seq = authPer1;
            if(resData.ApplicantsDtlsMyInfo.isFirstUser === 'true') {
                seq = authPer1;// first user, default return 1
            }
            else {// not first login person, get current login user seq from ApplicantDtls array
                if(resData.ApplicantDtls === null) { //SubAP, resData.ApplicantDtls should not be null. Redirect to Err Screen.
                    showErrMsg('Error: Invalid data.')
                    setIsLoading(false);
                    return;
                }

                if(!Array.isArray(resData.ApplicantDtls)){ //check obj
                    if(resData.ApplicantDtls.IDNumber ===  resData.ApplicantsDtlsMyInfo.IDNumber){
                        seq= resData.ApplicantDtls.OrderNumber;
                    }
                }
                else { //array
                    for(let i in resData.ApplicantDtls){
                        if(resData.ApplicantDtls[i].IDNumber === resData.ApplicantsDtlsMyInfo.IDNumber){
                            seq= resData.ApplicantDtls[i].OrderNumber;
                        }
                    }
                }
            }
     
            if(seq === authPer1) {
                setIsExpendAuth1(true);
                setIsExpendAuth2(true);
   
            }
            else if(seq === authPer2) {
                setIsExpendAuth1(false);
                setIsExpendAuth2(true);
     
            }
    
        }catch(ex) {
            console.log('@setAPExpendSection ex',ex);
            setIsLoading(false);
        }
    }

    const validateApplicantDtls = () => {
        
        if(getLoginUserOrder() === authPer1 && applicantDetails1.hasMyInfo) {
            return validateMyInfoMandatoryFields(applicantDetails1,'Authorised Person 1: ');
        }
        else if(getLoginUserOrder() === authPer2 && applicantDetails2.hasMyInfo) {
         
            return validateMyInfoMandatoryFields(applicantDetails2,'Authorised Person 2: ');
        }
        else {
            return true;
        }
    }
 
    const validateMyInfoMandatoryFields = (appDtls,title) => {
      
        let isValid = true;
        
        if(appDtls.myInfo.IDNumber === null || appDtls.myInfo.IDNumber === "" || appDtls.myInfo.IDNumber === undefined) {
            // console.log('invalid IDNum')
            isValid = false;
        }
        else if(appDtls.myInfo.DATE_OF_BIRTH === null || appDtls.myInfo.DATE_OF_BIRTH === "" || appDtls.myInfo.DATE_OF_BIRTH === undefined) {
            // console.log('invalid DOB')
            isValid = false;
        }
        else if(appDtls.myInfo.Gender === null || appDtls.myInfo.Gender === "" || appDtls.myInfo.Gender === undefined) {
            // console.log('invalid Gender')
            isValid = false;
        }
        else if(appDtls.myInfo.RACE_DESC === null || appDtls.myInfo.RACE_DESC === "" || appDtls.myInfo.RACE_DESC === undefined) {
            // console.log('invalid Race')
            isValid = false;
        }
        else if(appDtls.myInfo.NATIONALITY === null || appDtls.myInfo.NATIONALITY === "" || appDtls.myInfo.NATIONALITY === undefined) {
            // console.log('invalid Nationality')
            isValid = false;
        }
        else if(appDtls.myInfo.COUNTRY_OF_BIRTH === null || appDtls.myInfo.COUNTRY_OF_BIRTH === "" || appDtls.myInfo.COUNTRY_OF_BIRTH === undefined) {
            // console.log('invalid CnOfBirth')
            isValid = false;
        }
        else if(appDtls.myInfo.RESI_STS === null || appDtls.myInfo.RESI_STS === "" || appDtls.myInfo.RESI_STS === undefined) {
            // console.log('invalid ResStatus')
            isValid = false;
        }
        else if(appDtls.myInfo.Position_Code === null || appDtls.myInfo.Position_Code === "" || appDtls.myInfo.Position_Code === undefined) {
            // console.log('invalid Designation')
            isValid = false;  
        }
        else if(appDtls.myInfo.Position_Desc === null || appDtls.myInfo.Position_Desc === "" || appDtls.myInfo.Position_Desc === undefined) {
            // console.log('invalid Designation')
            isValid = false;  
        }
        // TODO: 17 Jul 2022, temporary disable. Need to put back when data file in place.
        else if(appDtls.myInfo.REG_ADD_TYPE !== config.addTypeForeign){
            if(appDtls.myInfo.REG_ADD_POSTAL_CODE === null || appDtls.myInfo.REG_ADD_POSTAL_CODE === "" || appDtls.myInfo.REG_ADD_POSTAL_CODE === undefined) {
                // console.log('invalid ResPostalCode')
                isValid = false;
            }
            else if(appDtls.myInfo.REG_ADD_BLOCK_NO === null || appDtls.myInfo.REG_ADD_BLOCK_NO === "" || appDtls.myInfo.REG_ADD_BLOCK_NO === undefined) {
                // console.log('invalid ResBlkNo')
                isValid = false;
            }
            else if(appDtls.myInfo.REG_ADD_STREET_NAME === null || appDtls.myInfo.REG_ADD_STREET_NAME === "" || appDtls.myInfo.REG_ADD_STREET_NAME === undefined) {
                // console.log('invalid ResStreet')
                isValid = false;
            }
        }
        else if(appDtls.myInfo.REG_ADD_TYPE === config.addTypeForeign) {
            if(appDtls.myInfo.REG_ADD_LINE1 === null || appDtls.myInfo.REG_ADD_LINE1 === "" || appDtls.myInfo.REG_ADD_LINE1 === undefined) {
                // console.log('invalid REG_ADD_LINE1')
                isValid = false;
            }
            else if(appDtls.myInfo.REG_ADD_LINE2 === null || appDtls.myInfo.REG_ADD_LINE2 === "" || appDtls.myInfo.REG_ADD_LINE2 === undefined) {
                // console.log('invalid REG_ADD_LINE2')
                isValid = false;
            }
        }
       
        return isValid;
    }

    const validateApplicantDtlsDOB = () => {
        if(getLoginUserOrder() === authPer1 && applicantDetails1.hasMyInfo) {
            return validateMyInfoDOBFormat(applicantDetails1,'Authorised Person 1: ');
        }
        else if(getLoginUserOrder() === authPer2 && applicantDetails2.hasMyInfo) {
            return validateMyInfoDOBFormat(applicantDetails2,'Authorised Person 2: ');
        }
        else {
            return true;
        }
    }
    
    const validateMyInfoDOBFormat = (appDtls,title) => {
        let isValid = true;
        if(appDtls.myInfo.DATE_OF_BIRTH !== null || appDtls.myInfo.DATE_OF_BIRTH !== "" || appDtls.myInfo.DATE_OF_BIRTH !== undefined){
            if(dobRegex.test(appDtls.myInfo.DATE_OF_BIRTH) === false) {
                // console.log('invalid DOB format')
                isValid = false;
            }
        }
        return isValid;
    }
  
    const validateForm = (authDtlsArray) => {
        let isValid = true;
        const errMsgDesp = 'Please do not leave field blank.\nPlease fill in the text field.'
        for(let i in authDtlsArray) {
            if(authDtlsArray[i].OrderNumber === authPer1) {
                if(!isValidFormInputFields(authDtlsArray[i], applicantDetails1.hasMyInfo)){
                    setIsExpendAuth1(true);
                    showErrMsg(errMsgDesp);
                    isValid = false;
                }
            }
            if(authDtlsArray[i].OrderNumber === authPer2) {
                if(!isValidFormInputFields(authDtlsArray[i], applicantDetails2.hasMyInfo)){
                    setIsExpendAuth2(true);
                    showErrMsg(errMsgDesp);
                    isValid = false;
                }
            }
        }
     
        return isValid;
    }
    
    const isValidFormInputFields = (formData, hasMyInfo) => {
 
        let isValid = true;
        if(hasMyInfo) {
            if(formData.TitleCode === '') {
                isValid = false;
            }
            else if(formData.MaritalStatusCode === '') {
                isValid = false;
            }
            else if(formData.MarStatusDesp === '') {
                isValid = false;
            }
            else if(formData.CountryOfResidenceCode === '') {
                isValid = false;
            }
            else if(formData.CountryOfResidenceDesc === '') {
                isValid = false;
            }
            else if(formData.MobileNumber === '') {
                isValid = false;
            }
            else if(formData.Email_Address === '') {
                isValid = false;
            }
        }
        else {
            if(formData.MobileNumber === '') {
                isValid = false;
            }
            else if(formData.Email_Address === '') {
                isValid = false;
            }
        }

        if(!isValid) {
            showErrMsg(personDtlsData.error.EmptyField);
        }
   
        return isValid;
    }
    
    const getData = () => {
        service.get().then( res => {
            if(res.data.isSucess) {
                if(res.data.model.fields === null) {
                    goToErrorPage(config.ErrType.EmptyAPDtls);
                    return;
                }
          
                if(res.data.model.fields.Data === "Empty") {  //MyInfo user click close, route to Product page.   
                    goToErrorPage(config.ErrType.EmptyAPDtls);
                    return;
                }
                
                if(checkIsLoginAPInHoldersArray(res.data.model.fields.request) === false) { //to prevent blank page if api return login AP NRIC not included in HoldersDetails List
                    goToErrorPage(config.ErrType.EmptyAPDtls);
                    return;
                }
 
                bindFormData(res.data.model.fields.request);
            }
            else{
                setIsLoading(false);
                showErrMsg(config.error.GetApiFailed);
            }
        })
        .catch(err=>{
            console.log('err: ',err);
            setIsLoading(false);
            goToErrorPage(config.ErrType.EmptyAPDtls);
            return;
        })
    }

    const bindFormData = (resData) => {
      
        const data = resData.ApplicantDtls;  //to check for first time or not
        const myInfoData = resData.ApplicantsDtlsMyInfo;  // Login user 
       
        try{
            if(myInfoData && myInfoData !== null) { // check correct api response
                isFProductBTL(resData);
                isFProdProperty(resData);
                setResponse(resData);
                setAPExpendSection(resData);
                storage.setIsFirstTime(myInfoData.isFirstUser === 'true'? true:false);
                createCPFHistory(myInfoData);
                createAPYrofAssestment(myInfoData);
               
                if(data && data !== null) {  //not first time
                    if(data.length !== 0) { //not first time
   
                        bindAppDtlsFormData(resData)
                    }
                }
                else { // first time
                    bindFirstTime(resData);
                }
                
            }
            else {
                goToErrorPage(config.ErrType.EmptyAPDtls);
                setIsLoading(false);
            }
        }
        catch(ex) {
            console.log('bindFormData ',ex);
        }
    }

    const checkIsLoginAPInHoldersArray = (data) => {
        let isValid = false;
        let holdersArray = getHoldersDtls(data);
        let loginAPIDNo = data.ApplicantsDtlsMyInfo.IDNumber;
        let result = null;
        if(loginAPIDNo !== null){
            try {
                result = holdersArray.find( ({ IDNumber }) => IDNumber === loginAPIDNo);
           
                if(result === null || result === undefined) {
                    isValid = false;
                }
                else {
                    isValid = true;
                }
            }
            catch(e) {

            }
        }

        return isValid;
    }
  
    const bindFirstTime = (resData) => {
 
        const myInfoData = resData.ApplicantsDtlsMyInfo;
        
        let allHolders = getHoldersDtls(resData);
       
        setHolders(allHolders);
        let nonLoginHolders = []; 
        //setExpendSection(myInfoData.isFirstUser,authPer1)
    
        for(let i in allHolders) {
            if(myInfoData.IDNumber.trim() === allHolders[i].IDNumber.trim()) {
                let authPer1 = {
                    myInfo:myInfoData,
                    allowEdit:true,
                    contactDtlEdit:true,
                    hasMyInfo:true,
                    showCPFAndNOA:true
                 }
                setApplicantDetails1(authPer1); 
            }
            else { //Remove Login Person in Holders 
                
                nonLoginHolders.push(allHolders[i]);
            }
        }
        setIsLoading(false);
    }

    const bindAppDtlsFormData = (data) => {
    
        let appDtls1=null, appDtls2=null, appDtls3=null, appDtls4=null, appDtls5=null;

        let allHolders = getHoldersDtls(data);
        setHolders(allHolders);

        if(!Array.isArray(data.ApplicantDtls)) {
            appDtls1 = data.ApplicantDtls;
        }
        else {
            for(let i in data.ApplicantDtls) {
                if(data.ApplicantDtls[i].OrderNumber === authPer1){
              
                    appDtls1= data.ApplicantDtls[i];
                }

                if(data.ApplicantDtls[i].OrderNumber === authPer2) {
                    appDtls2 = data.ApplicantDtls[i];
                }
            }
        }
  
        if(appDtls1 !== null){
            setApplicantDetails1({
                myInfo:getAuthDtlsData(appDtls1,data),
                allowEdit:checkAllowEdit(appDtls1,data.ApplicantsDtlsMyInfo),
                contactDtlEdit:checkContactDtlsEdit(data.ApplicantsDtlsMyInfo),
                hasMyInfo:getHasMyInfoAP1(appDtls1,data),
                showCPFAndNOA:showAPCPFAndNOA(appDtls1,data.ApplicantsDtlsMyInfo)
            })
        }

   
        if(appDtls2 !== null){ 
            setApplicantDetails2({
                myInfo:getAuthDtlsData(appDtls2,data),
                allowEdit:checkAllowEdit(appDtls2,data.ApplicantsDtlsMyInfo),
                contactDtlEdit:checkContactDtlsEdit(data.ApplicantsDtlsMyInfo),
                hasMyInfo:getHasMyInfoAP2(appDtls2,data),
                showCPFAndNOA:showAPCPFAndNOA(appDtls2,data.ApplicantsDtlsMyInfo)
            })
        }

        setInitFormData({
            titleCbo1:appDtls1 !== null && appDtls1.TitleCode? helper.getObjInArray(appDtls1.TitleCode,titles):'',
            marStatusCbo1:appDtls1 !== null && appDtls1.MaritalStatusCode? helper.getObjInArray(appDtls1.MaritalStatusCode,marStatusArray):'',
            countOfDomicileCbo1:appDtls1 !== null && appDtls1.CountryOfResidenceCode? helper.getObjInArray(appDtls1.CountryOfResidenceCode,countriesDomicile):'',
            mno1:appDtls1 !== null && appDtls1.MobileNumber? appDtls1.MobileNumber:'',
            em1:appDtls1 !== null && appDtls1.Email_Address? appDtls1.Email_Address:'',
            mhLoanInstallmentCbo1: appDtls1 !== null && appDtls1.isJointContributerForMortgageLoan? helper.getObjInArray(appDtls1.isJointContributerForMortgageLoan,personDtlsData.mhLoanInstallmentData):'', 
            
            cboAuthrisedPerson: appDtls2 !==null && appDtls2.IDNumber? helper.getObjInArray(appDtls2.IDNumber,allHolders):'',
            titleCbo2:appDtls2 !== null && appDtls2.TitleCode? helper.getObjInArray(appDtls2.TitleCode,titles):'',
            marStatusCbo2:appDtls2 !== null && appDtls2.MaritalStatusCode? helper.getObjInArray(appDtls2.MaritalStatusCode,marStatusArray):'',
            countOfDomicileCbo2:appDtls2 !== null && appDtls2.CountryOfResidenceCode? helper.getObjInArray(appDtls2.CountryOfResidenceCode,countriesDomicile):'',
            mno2:appDtls2 !== null && appDtls2.MobileNumber? appDtls2.MobileNumber:'',
            em2:appDtls2 !== null && appDtls2.Email_Address? appDtls2.Email_Address:'',
            mhLoanInstallmentCbo2: appDtls2 !== null && appDtls2.isJointContributerForMortgageLoan? helper.getObjInArray(appDtls2.isJointContributerForMortgageLoan,personDtlsData.mhLoanInstallmentData):'' 
     
             
        })

        setIsLoading(false);
    }

    const goToErrorPage = (errType) => {
        setIsLoading(false);
        props.history.push(config.route.InvalidEntity,{errType:errType});
    }

    const getAuthDtlsData = (authPerson,resData) => {
        if(authPerson.IDNumber.trim() === resData.ApplicantsDtlsMyInfo.IDNumber.trim()){ // get the login's person
            return resData.ApplicantsDtlsMyInfo;  // return login user info
        }
        else {
            return authPerson;  //return from AuthDtls Array's object
        }
    }

    const showAPCPFAndNOA = (authPerson,loginPerson) => {
        if(authPerson.IDNumber.trim() === loginPerson.IDNumber.trim()) {  //login user
            return true;
        }
        else {
            return false;
        }
    }

    const checkAllowEdit = (authPerson,loginPerson) => {
 
        if(loginPerson.isFirstUser === 'true') {
            return true;
        }
        else if(authPerson.IDNumber.trim() === loginPerson.IDNumber.trim()) {  //login user
            return true;
        }
        else {
            return false;
        }
    }

    const checkContactDtlsEdit = (loginPerson) => {
        if(loginPerson.isFirstUser === 'true') {  //first user
            return true;
        }
        else {
            return false;
        }
    }

    const getHasMyInfoAP1 = (authPerson,resData) => {
     
        if(authPerson.IDNumber === resData.ApplicantsDtlsMyInfo.IDNumber){
            return true;
        }
        else if(resData.SubmittedApplicants.Applicant1 === 'true') {
            return true;
        }
        else {
            return false;
        }
    }

    const getHasMyInfoAP2 = (authPerson,resData) => {
      
        if(authPerson.IDNumber.trim() === resData.ApplicantsDtlsMyInfo.IDNumber.trim()){
 
            return true;
        }
        else if(resData.SubmittedApplicants.Applicant2  === 'true') {
      
            return true;
        }
        else {
            return false;
        }
    }

    const getHasMyInfoAP3 = (authPerson,resData) => {
        if(authPerson.IDNumber.trim() === resData.ApplicantsDtlsMyInfo.IDNumber.trim()){
            return true;
        }
        else if(resData.SubmittedApplicants.Applicant3  === 'true') {
            return true;
        }
        else {
            return false;
        }
    }

    const getHasMyInfoAP4 = (authPerson,resData) => {
        if(authPerson.IDNumber.trim() === resData.ApplicantsDtlsMyInfo.IDNumber.trim()){
            return true;
        }
        else if(resData.SubmittedApplicants.Applicant4  === 'true') {
            return true;
        }
        else {
            return false;
        }
    }

    const getHasMyInfoAP5 = (authPerson,resData) => {
        if(authPerson.IDNumber.trim() === resData.ApplicantsDtlsMyInfo.IDNumber.trim()){
            return true;
        }
        else if(resData.SubmittedApplicants.Applicant5  === 'true') {
            return true;
        }
        else {
            return false;
        }
    }

 

    const getHoldersDtls = (data) => {
        let temp = [];
        if(!Array.isArray(data.Holdersdetails)) {
            // temp.push(myInfoAppDtls); //no need to add login user
            if(data.Holdersdetails.IDNumber !== null && data.Holdersdetails.Person_Name !== null) {
                temp.push(data.Holdersdetails);
            }
        }
        else {
            // temp.push(myInfoAppDtls); //no need to add login user
            for(let i in data.Holdersdetails) {
                if(data.Holdersdetails[i].IDNumber !== null && data.Holdersdetails[i].Person_Name !== null){
                    temp.push(data.Holdersdetails[i]);
                }
            }
        }

        return temp;
    }

    const createCPFHistory = (data) => {
        try{
            let temp = [], min=[], max = [];
            if(data.cpfContributionHistory && data.cpfContributionHistory !== null) {
                if(!Array.isArray(data.cpfContributionHistory)) {
                    temp.push(data.cpfContributionHistory);
                }
                else {
                    temp = data.cpfContributionHistory;
                }
        
                for (let i in temp) {
                    max.push(temp[i]);
                    if(i < 2) min.push(temp[i]);
                }
                
                setLoginAPCPFHistory({
                    minData:min,
                    maxData:max
                });
            }
            else {
                setLoginAPCPFHistory({
                    minData:min,
                    maxData:max
                });
            }
        }catch(ex) {
            setIsLoading(false);
        }
    }

    const createAPYrofAssestment = (data) => {
      
        if(data.yearOfAssessment && data.yearOfAssessment !== null && data.yearOfAssessment.income !==null) {
            let firstYrData = null;
            let secYrData = null;

            if(!Array.isArray(data.yearOfAssessment.income)) { // object
              firstYrData = data.yearOfAssessment.income;
              secYrData = null;
            }
            else { // array
               for(let i in data.yearOfAssessment.income) {
                 if(data.yearOfAssessment.income[i].RowNumber === "1") {
                    firstYrData = data.yearOfAssessment.income[i];
                 }
                 else if(data.yearOfAssessment.income[i].RowNumber === "2") {
                    secYrData = data.yearOfAssessment.income[i];
                 }
               }
            }
            
            setLoginAPYrAssestment({
                firstYear: {
                    employment: firstYrData === null? null: firstYrData.employment,
                    taxCategory: firstYrData === null? null:firstYrData.taxCategory,
                    year:firstYrData === null? null:firstYrData.year,
                    taxClearance: firstYrData === null? null:firstYrData.taxClearance,
                    assessableIncome: firstYrData === null? null:firstYrData.assessableIncome,
                    trade: firstYrData === null? null:firstYrData.trade,
                    rent: firstYrData === null? null:firstYrData.rent,
                    interest: firstYrData === null? null:firstYrData.interest
                  },
                  secondYear: {
                    employment: secYrData === null? null: secYrData.employment,
                    taxCategory: secYrData === null? null: secYrData.taxCategory,
                    year:secYrData === null? null: secYrData.year,
                    taxClearance: secYrData === null? null: secYrData.taxClearance,
                    assessableIncome: secYrData === null? null: secYrData.assessableIncome,
                    trade: secYrData === null? null: secYrData.trade,
                    rent: secYrData === null? null: secYrData.rent,
                    interest: secYrData === null? null: secYrData.interest
                  }
            });
        }
        else {
            setLoginAPYrAssestment({
                firstYear: {
                    employment: null,
                    taxCategory: null,
                    year:null,
                    taxClearance: null,
                    assessableIncome: null,
                    trade: null,
                    rent: null,
                    interest: null
                  },
                  secondYear: {
                    employment: null,
                    taxCategory: null,
                    year:null,
                    taxClearance: null,
                    assessableIncome: null,
                    trade: null,
                    rent: null,
                    interest: null
                  }
            });
        }
    }
    
    const showErrMsg = (msg) => {
        setIsError(true);
        setErrMsg(msg);
        setErrMsgTimeout();
    }

    const setErrMsgTimeout= () => {
        timer = setTimeout(() => {
            setIsError(false);
        }, config.error.msgTimeout);
    }

    const goNext = () => {
        
        storage.setIsAPSavedForm(true);
        if(history.location.state !== undefined) {
            if(history.location.state.from === config.route.Preview) {
                history.goBack();
            }
        }
        else {
            if(storage.getIsFirstTime()=== "true") {
                if(storage.getIsFProdBTL() === 't') { //existing
                    history.push(config.route.AccountDetails);//exsting
                }
                else {
         
                    if(storage.getIsFPTypeProperty() === 't') { 
                       
                        if(storage.getIsPureAIP() === 'true') {
                            history.push(config.route.PropertyDetailsAIP);
                        }
                        else {
                            history.push(config.route.PropertyDetails);
                        }
                
                    }
                    else {
                        history.push(config.route.DeclarationsDetails); // declarations
                    }
                }
            }
            else {
                history.push(config.route.DeclarationsDetails);
            }
        
        }
    }

    const isFirstUser = () => {
        if(response && response.ApplicantsDtlsMyInfo.isFirstUser==='true') {
            return true;
        }
        else {
            return false;
        }
    }

    const isFProductBTL = (res) => {
        let result = false;
        const resData = res.Request_Form;
        if(resData) {
            if(resData.FinancingProduct === mData.bizFinanceType.Online) { //existing BTL
                result = true;
            }
            else if(resData.FinancingProduct === mData.bizFinanceType.Personalised) { //PBF 
                result = false;
            }
        }
  
        storage.setIsFProdBTL(result?'t':'f');
    }

    const isFProdProperty = (res)=> {
        let result = false;
        const resData = res.Request_Form;
        if(resData) {
            if(resData.Property === 'Y') { //property selected
                result = true;
            }
            else if(resData.FinancingProduct === mData.bizFinanceType.AIP) { //PBF 
                result = true;
            }
        }
  
        storage.setIsFPTypeProperty(result?'t':'f');
    }
    
    if(isLoading) {
        return(
          <Loading />
        )
    }

    return(
        <div className="container-fluid"> 
            <SubHeader title={config.Branding.title}
                img={!isFirstUser()?subAPImg:(storage.getIsFProdBTL() === 't')?headerImg:storage.getIsFPTypeProperty() === 't'?pStepper:stepper} /><br/>
                <Form onSubmitClick={handleSubmit}
                    initialValues= {initFormData}
                    key={JSON.stringify(initFormData)}
                    render={(formRenderProps)=>(
                        <FormElement>
                           <FormContainer>
                            <fieldset>
                                <Field component={FormTitle} id={personDtlsData.formContainerTitle.T1} name={personDtlsData.formContainerTitle.T1.name} />
                                <div>
                                <Field component={CusFormSectionLabel} 
                                    id={'Per'+authPer1} 
                                    name={applicantDetails1.myInfo.Person_Name !== null? applicantDetails1.myInfo.Person_Name:''}
                                    rightlblId={'lblPer1'} rightlblName={'Fill Up Form'}
                                    isExpend={isExpendAuth1}
                                    doneMyInfo ={applicantDetails1.hasMyInfo}
                                    onClick={() => {
                                        if(isExpendAuth1){
                                            setIsExpendAuth1(false);
                                        }
                                        else {
                                            setIsExpendAuth1(true);
                                        } 
                                    }} />
                                {isExpendAuth1 &&
                                    <div>
                                    <FieldWrapper>
                                    <div className="row around-xs inputPair elementVisible">
                                  <div className="col-xs-12 col-sm-3 col-md-3 col-lg-3">
                                            <div className="box" style={{ marginTop: "5px" }}>{personDtlsData.label.n}</div>
                                        </div>
                                        <ToggleShowDetails id={authPer1} toggle={showMyInfoPersonDtls1} onToggleClick={handleOnToggleClick} />
                                        <div className="col-xs-12 col-sm-6 col-md-6 col-lg-6">
                                            <div className="box">{applicantDetails1.myInfo.Person_Name}</div>
                                        </div>
                                    </div>
                                    </FieldWrapper>
                                    {showMyInfoPersonDtls1 && 
                                    <MyInfoPersonDetails personDetails={applicantDetails1} order={authPer1} />
                                    }
                                <AuthPerson 
                                    applicantDetails={applicantDetails1} showDetails={showMyInfoPersonDtls1} formRenderProps={formRenderProps}
                                    hasMyInfo={applicantDetails1.hasMyInfo} seq={authPer1} holders={holders} 
                                    cpfHistory={loginAPCPFHistory} yrOfAssessment={loginAPYrAssestment} /> 
                                    </div>
                                }
                                </div>

                            {/* Auth Person 2 */}
                            {/* {applicantDetails2 !== null && */}
                                <div>
                                <Field component={CusFormSectionLabel} 
                                    id={'Per'+authPer2} 
                                    name={applicantDetails2.myInfo.Person_Name !== null? applicantDetails1.myInfo.Person_Name:'Authorised Person'}
                                    rightlblId={'lblPer'+authPer2} 
                                    rightlblName={applicantDetails2.hasMyInfo? 'Fill Up Form':'Fill Up Contact'}
                                    isExpend={isExpendAuth2}
                                    doneMyInfo ={applicantDetails2.hasMyInfo}
                                    onClick={() => {
                                        if(isExpendAuth2){
                                            setIsExpendAuth2(false);
                                        }
                                        else {
                                            setIsExpendAuth2(true);
                                        } 
                                    }} />
                                    {isExpendAuth2 &&
                                    <div>
                                    {applicantDetails2.hasMyInfo && 
                                    <FieldWrapper>
                                        <div className="row around-xs inputPair elementVisible">
                                            <div className="col-xs-12 col-sm-3 col-md-3 col-lg-3">
                                                <div className="box" style={{ marginTop: "5px" }}>{personDtlsData.label.n}</div>
                                            </div>
                                            <ToggleShowDetails id={authPer2} toggle={showMyInfoPersonDtls2} onToggleClick={handleOnToggleClick} />
                                            <div className="col-xs-12 col-sm-6 col-md-6 col-lg-6">
                                                <div className="box">{applicantDetails2.myInfo.Person_Name}</div>
                                            </div>
                                        </div>
                               
                                        {showMyInfoPersonDtls2 && 
                                            <MyInfoPersonDetails personDetails={applicantDetails2} order={authPer1} />
                                        }
                                    </FieldWrapper>
                                    }
                                    <FieldWrapper>
                                        <Field 
                                            component={CusFormComboBox}
                                            id={'cboAuthorisedPerson'}
                                            name={'cboAuthorisedPerson'}
                                            leftLabelId={'lblnameCbo'} 
                                            leftLabelName={personDtlsData.label.n}
                                            placeholder={'Please select'} 
                                            textField={'Person_Name'}
                                            data={holders} 
                                            validator={reqDDLValidator} 
                                        />
                                    </FieldWrapper>
                                    <AuthPerson 
                                        applicantDetails={applicantDetails2} showDetails={showMyInfoPersonDtls2} formRenderProps={formRenderProps}
                                        hasMyInfo={applicantDetails2.hasMyInfo} seq={authPer2} holders={holders}
                                        cpfHistory={loginAPCPFHistory} yrOfAssessment={loginAPYrAssestment} />

                                    </div>
                                    }
                                </div>

                            {/* } */}
                            </fieldset>
                            <br/>
                            </FormContainer>
                            <FormContainer>
                                <div style={{paddingTop:'20px',paddingBottom: "20px"}}>
                                    <div className="row around-xs inputPair elementVisible">
                                        <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12" >
                                            <Button type={'submit'} className="k-button btn btnMargin btn-success btn-float-right" 
                                                disabled={!formRenderProps.valid}>
                                                {config.btnName.Next}
                                            </Button>
                                            <Button type={"button"} style={{border:'1px solid #343a40'}}
                                                className="k-button btn btnMargin btn-back"
                                                disabled={response.ApplicantsDtlsMyInfo.isFirstUser === 'false'? true:false} 
                                                onClick={(e) => { 
                                                    e.preventDefault(); 
                                                    history.push(config.route.CompanyDetails+'?state='+storage.getStateId());}}>
                                                {config.btnName.Back}
                                            </Button>
                                        </div>
                                    </div> 
                                </div>
                            </FormContainer>
                            <FieldWrapper></FieldWrapper>
                        </FormElement>
                    )}>
                </Form>
            <CusToast className="popUpBox" trigger={isError} setTrigger={setIsError} label={errMsg} timer={timer}  /> 
            {isSaving && <Loading />}
        </div>
    )
}

export default SPersonDetails;